import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "map-legend" }
const _hoisted_2 = {
  key: 0,
  class: "map-legend__title"
}
const _hoisted_3 = { class: "map-legend__marks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "map-legend__scale",
      style: _normalizeStyle({ background: _ctx.background })
    }, null, 4),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.marks, (mark) => {
        return (_openBlock(), _createElementBlock("span", { key: mark }, _toDisplayString(mark), 1))
      }), 128))
    ])
  ]))
}